import React from "react";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";

const FinancialYearSelector = ({
  financialYears,
  selectedFY,
  setSelectedFY,
}) => {
  return (
    <FormControl style={{ marginRight: "5px" }} size="small">
      <InputLabel>Financial Year</InputLabel>
      <Select
        label="Financial Year"
        value={selectedFY || ""}
        onChange={(e) => setSelectedFY(e.target.value)}
        style={{ minWidth: 120 }}
      >
        <MenuItem value="all">All</MenuItem>
        {financialYears.map((fy) => (
          <MenuItem key={fy.id} value={fy.id}>
            {fy.description}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default FinancialYearSelector;
